import React, { useReducer } from "react";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  FormLabel,
} from "@mui/material";
import authService from "services/authService";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { resetPasswordFormReducer } from "reducers/formReducers";
import PropTypes from "prop-types";

const initialValue = {
  showPassword: true,
  username: "",
  password: "",
  confirmPassword: "",
  errors: {},
};

function ResetPasswordForm({
  responseFunc,
  loadingStatusFunc,
  verificationToken,
}) {
  const [formState, dispatch] = useReducer(
    resetPasswordFormReducer,
    initialValue
  );

  const { showPassword, confirmPassword, password, errors, showCPassword } =
    formState;

  const toggleShow = () => {
    dispatch({
      type: "showPassword",
      payload: {
        showPassword: !showPassword,
      },
    });
  };

  const toggleConfirmShow = () => {
    dispatch({
      type: "showConfirmPassword",
      payload: {
        showCPassword: !showCPassword,
      },
    });
  };

  const onChange = (e) => {
    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
    dispatch({ type: "validation", errors: initialValue.errors });
  };

  const validateForm = () => {
    let formIsValid = true;
    const issues = {};
    if (!password) {
      formIsValid = false;
      issues.password = "*Please enter your password.";
    } else if (typeof password !== "undefined") {
      const pattern = /^[A-Za-z]\w{7,14}$/;
      if (!pattern.test(password)) {
        formIsValid = false;
        issues.password = "*Your password must be 8 charcters longs or more.";
      }
    }
    if (!confirmPassword) {
      formIsValid = false;
      issues.confirmPassword = "*Please enter your confirm password.";
    }
    if (password && confirmPassword && password !== confirmPassword) {
      issues.wrongPassword = "(Your Passwords Do Not Match)";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationResults = validateForm();
    if (validationResults) {
      loadingStatusFunc(true);
      authService
        .updatePasswordApi(password, verificationToken)
        .then((result) => {
          responseFunc(result);
        });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="left-padding" id="underlinehide">
        <div className="default-card-body-padding">
          <span className="default-card-body-text">
            Your new password must be different from previously used passwords.
          </span>
        </div>
        <div className="default-card-body-padding">
          <FormLabel htmlFor="password" className="default-label-text">
            New Password
          </FormLabel>
          <TextField
            name="password"
            id="password"
            type={showPassword ? "password" : "text"}
            value={password}
            onChange={onChange}
            variant="standard"
            InputProps={{
              disableUnderline: true,

              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={toggleShow}
                  >
                    {showPassword === false ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div className="errorMsg">{errors.password}</div>
          <div className="left-padding">
            <FormLabel htmlFor="confirmPassword" className="default-label-text">
              Confirm Password
            </FormLabel>
            <span className="dafault-font-family">{errors.wrongPassword}</span>
            <TextField
              name="confirmPassword"
              id="confirmPassword"
              type={showCPassword ? "password" : "text"}
              value={confirmPassword}
              onChange={onChange}
              variant="standard"
              InputProps={{
                disableUnderline: true,

                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={toggleConfirmShow}
                    >
                      {showCPassword === false ? (
                        <VisibilityOutlinedIcon id="cp" />
                      ) : (
                        <VisibilityOffOutlinedIcon id="cp" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {errors && errors.confirmPassword !== "" && (
              <span className="b-loginform-container__errorMsg errorMsg">
                {errors.confirmPassword}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="default-card-body-padding">
        <Button className="remove" variant="standard" type="submit">
          <span className="default-card-header-text"> Reset Password</span>
        </Button>
      </div>
    </form>
  );
}

ResetPasswordForm.propTypes = {
  responseFunc: PropTypes.func.isRequired,
  loadingStatusFunc: PropTypes.func.isRequired,
  verificationToken: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
